import React from 'react';
export function TipIcon(props) {
  var className = props && props.className ? 'wink-icon ' + props.className : 'wink-icon';
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    "aria-hidden": "true"
  }, props, {
    className: className
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 4.818a1 1 0 001-1V2a1 1 0 00-2 0v1.818a1 1 0 001 1zM6.921 6.922a1 1 0 000-1.414L5.636 4.222a1 1 0 00-1.414 1.414l1.285 1.286a1 1 0 001.414 0zM3.818 11H2a1 1 0 000 2h1.818a1 1 0 000-2zM22 11h-1.818a1 1 0 000 2H22a1 1 0 000-2zM19.778 4.222a1 1 0 00-1.414 0l-1.285 1.286a1 1 0 101.414 1.414l1.285-1.286a1 1 0 000-1.414z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 5.546a6.451 6.451 0 00-4.035 11.487.805.805 0 01.308.63v2.519A2.82 2.82 0 0011.091 23h1.818a2.82 2.82 0 002.818-2.818v-2.52a.806.806 0 01.308-.63A6.451 6.451 0 0012 5.547zM12.909 21h-1.818a.819.819 0 01-.818-.818V18.8h3.454v1.382a.818.818 0 01-.818.818zm1.877-5.53a2.8 2.8 0 00-.9 1.33H13v-1.828a2.817 2.817 0 001.818-2.627 1 1 0 10-2 0 .818.818 0 01-1.636 0 1 1 0 10-2 0A2.815 2.815 0 0011 14.972V16.8h-.881a2.8 2.8 0 00-.9-1.33 4.455 4.455 0 115.572 0h-.005z"
  }));
}